import React from 'react';
import { SearchFullNamePopup, ListInfoDocumentDialog, ThongTinNguoiDungDon, ThongTinDon } from 'modules/reception';
import { Link, browserHistory } from 'react-router';
import { msg } from "constants/message";
import { LetterProcessingWorkFlow, Reception, GiaiQuyetDonThu, Danhmuc, DuLieuHeThong } from 'api';
import { connect } from 'react-redux';
import { Toastr } from 'modules/toastr';
import { API_URL, DateFormat } from 'constants/config';
import moment from 'moment';
import LoadingData from 'layout/partials/LoadingData.jsx';
import { DatePicker, Input } from 'components/tt-forms/common';
import { DropDownChonNguonDon } from 'components/tt-forms';
import { FormXuLyHoacGiaiQuyet } from 'modules/handle-letters/xu-ly-don';
import ButtonGroup from 'modules/handle-letters/button-group';
import LetterHistory from 'modules/letter-history';
import { ShowIf } from 'components/utils';
import {ConfirmDialog, MaTraCuuDialog} from 'modules/dialog';
import { get } from 'lodash';

class AddHandleLetter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

      btnLoading: false,
      btnSaveLoading: false,
      btnDisable: false,
      // Thong tin nguoi xu ly
      canBoDangXuLy: [],
      donDangXuLy: true,
      title: 'THÔNG TIN XỬ LÝ',
      huongXuLy: '',
      donId: (this.props.params.id ? this.props.params.id : 0),
      alias: '',
      listNextStates: [],
      params: {},
      data: {},
      validate: false,
      processType: '',
      thongTinXuLy: {},
      showHistory: true,

      dataLoading: false,
      thoiHan: '',
      ngayTiepNhan: moment(),
      taskDelete: [],
      doanDongNguoi: [],
      loadingSave: false,
      loadingXLD: false,
      thanhLapDon: false,
      soThuTuLuotTiep: 1,
      tongSoLuotTCD: 1,

      lanhDaoId: 0,
      isFinish: false,
      openConfirmDialog: false,
      confirmIndex: '',
      confirmData: {},
      isValid: true,
      nguonDon: 'BUU_CHINH',
      loaiNguoiDungDonId: 'CA_NHAN',

      listTaiLieuVanThu: [],

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],

      loaiTepDinhKem: '',
      loaiQuyTrinh: '',

      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      noticeMsg: '',
      backConfirm: false,
      hasChange: false,
      isSave: false,
      saveTmp: true,
      maTraCuuDialog: false,
      maTraCuu: '',
      nguonDonKhac: '',
      daLayThongTinDonId: '',
      noiCapCMNDList: this.props.noiCapCMNDList,
      checkValidate: false,
    };
  }

  componentWillUnmount() {

    this.props.dispatch({
      type: 'RESET_FORM'
    });
  }

  componentDidMount() {
    if (this.props.params.id) {
      this.getDonInfo(this.props.params.id)
      this.getCurrentForm(this.state.donId);
      this.getThongTinXuLy(this.state.donId);
    } else {
      this.getCurrentForm(null);
    }
    if(this.props.noiCapCMNDList.length == 0) {
      DuLieuHeThong.actions.getNoiCap.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'noiCapCMND',
            data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.removeDonCongDanId) {
      this.state.taskDelete.push({
        type: 'CONG_DAN',
        id: nextProps.removeDonCongDanId
      });
    }
    if (nextProps.thongTinDon && nextProps.thongTinDon.donId) {
      this.setState({daLayThongTinDonId: nextProps.thongTinDon.donId});
    }
    if (nextProps.noiCapCMNDList != this.props.noiCapCMNDList) {
      this.state.noiCapCMNDList = nextProps.noiCapCMNDList;
      this.setState({...this.state})
    }
  }

  onChangeData(data) {

    let newData = {
      ...this.state,
      ...data
    };
    this.state = newData;
    this.state.hasChange = true;
    this.setState({ ...this.state });
  }

  onInitComponent(data) {
    let newData = {
      ...this.state,
      ...data
    };
    this.state = newData;
    this.setState({...this.state});
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value,
      hasChange: true
    })
  }

  handleChange(e) {
    this.state[e.target.name] = e.target.value;
    this.state.hasChange = true;
    this.setState({ ...this.state });
    if (e.target.name == 'huongXuLy') {
      this.setState({
        ghiChuXuLy: ''
      });
    }
  }

  handleChangeDate(name, e) {
    if (typeof e.format == 'function') {
      this.state[name] = e.format(DateFormat);
    } else {
      this.state[name] = e;
    }
    this.state.hasChange = true;
    this.setState({ ...this.state });
  }

  handleRemove(name, data) {
    if (name == 'DOAN_DI_CUNG' && data.doanDiCungId) {
      this.state.taskDelete.push({
        type: 'DOAN_DI_CUNG',
        id: data.doanDiCungId
      });
    } else if (name == 'CONG_DAN' && data.donCongDanId) {
      this.state.taskDelete.push({
        type: 'CONG_DAN',
        id: data.donCongDanId
      });
    } else if (name == 'BANG_CHUNG' && data.taiLieuBangChungId) {
      this.state.taskDelete.push({
        type: 'BANG_CHUNG',
        id: data.taiLieuBangChungId
      });
    } else if (name == 'TEP_DINH_KEM' && data.taiLieuVanThuId) {
      this.state.taskDelete.push({
        type: 'TEP_DINH_KEM',
        id: data.taiLieuVanThuId
      });
    }
    this.state.hasChange = true;
    this.setState({ ...this.state });
  }

  phanLoaiDonCongDan(donId, onlySave) {
    let plusData = {};
    let AddNewDCDList = [];
    let UpdateDCDList = [];
    let AddNewTLList = [];
    let UpdateTLList = [];
    let AddNewDDCList = [];
    let UpdateDDCList = [];

    if (this.state.loaiNguoiDungDonId == 'CO_QUAN_TO_CHUC') {
      plusData = {
        tenCoQuan: this.state.tenCoQuan,
        diaChiCoQuan: this.state.diaChiCoQuan,
        soDienThoaiCoQuan: this.state.soDienThoai
      }
    }

    this.props.nguoiDungDon.map((item, i) => {
      if (item.hoVaTen) {
        let nddData = this.createCongDan(item, 'NGUOI_DUNG_DON');
        let donCdData = this.createDonCongDan(nddData, donId, plusData, 'NGUOI_DUNG_DON');
        if (donCdData.id) {
          UpdateDCDList.push(donCdData);
        } else {
          AddNewDCDList.push(donCdData);
        }
      }
    });

    this.state.doanDongNguoi.map((item, i) => {
      if (item.hoVaTen) {
        let ddcData = this.createItemDoanDiCung(item, donId);
        if (ddcData.id)
          UpdateDDCList.push(ddcData);
        else
          AddNewDDCList.push(ddcData);
      }
    });
    if (this.state.flagUyQuyen) {
      if (this.state.uyQuyen && this.state.uyQuyen.flagLuatSu) {
        plusData.luatSu = this.state.uyQuyen.flagLuatSu;
        if (this.state.uyQuyen.luatSu.soTheLuatSu) {
          plusData.soTheLuatSu = this.state.uyQuyen.luatSu.soTheLuatSu;
        }
        if (this.state.uyQuyen.luatSu.ngayCapTheLuatSu) {
          plusData.ngayCapTheLuatSu = moment(this.state.uyQuyen.luatSu.ngayCapTheLuatSu, 'DD/MM/YYYY').add(7, 'hours');
        }
        if (this.state.uyQuyen.luatSu.noiCapTheLuatSu) {
          plusData.noiCapTheLuatSu = this.state.uyQuyen.luatSu.noiCapTheLuatSu;
        }
        if (this.state.uyQuyen.luatSu.thongTinGioiThieu) {
          plusData.thongTinGioiThieu = this.state.uyQuyen.luatSu.thongTinGioiThieu;
        }

        this.state.uyQuyen.luatSu.dsGiayUyQuyen.map((item, i) => {
          let tlParams = this.createTaiLieuBangChung(item, donId, '', 'LUAT_SU');
          if (tlParams.id)
            UpdateTLList.push(tlParams);
          else
            AddNewTLList.push(tlParams);
        });
      } else {
        plusData.luatSu = false;
      }

      let nddData = this.createCongDan(this.props.nguoiUyQuyen, 'NGUOI_DUOC_UY_QUYEN');
      let donCdData = this.createDonCongDan(nddData, donId, plusData, 'NGUOI_DUOC_UY_QUYEN');
      if (donCdData.id)
        UpdateDCDList.push(donCdData);
      else
        AddNewDCDList.push(donCdData);
    }

    this.state.thongTinDon.dsBangChung.map((item, i) => {
      let tlParams = this.createTaiLieuBangChung(item, donId);
      if (tlParams.id)
        UpdateTLList.push(tlParams);
      else
        AddNewTLList.push(tlParams);
    });

    if (AddNewDCDList.length) {
      Reception.actions.postDonCongDanMulti.request('', { donCongDans: AddNewDCDList }).then(() => {
        if (this.state.donDangXuLy) {
          if (onlySave)
            this.patchXuLyDon(donId, this.state.params);
          else
            this.postXuLyDon(donId, this.state.params);
        } else {
          this.onClickClose();
          Toastr(msg.xuLyDon, 'success');
        }
      });
    }

    if (UpdateDCDList.length) {
      Reception.actions.updateDonCongDanMulti.request('', { donCongDans: UpdateDCDList }).then(() => {
        if (this.state.donDangXuLy) {
          if (onlySave)
            this.patchXuLyDon(donId, this.state.params);
          else
            this.postXuLyDon(donId, this.state.params);
        } else {
          this.onClickClose();
          Toastr(msg.xuLyDon, 'success');
        }
      });
    }


    if (AddNewTLList.length) {
      Reception.actions.postTaiLieuBangChungMulti.request('', { taiLieuBangChungs: AddNewTLList });
    }
    if (UpdateTLList.length) {
      Reception.actions.updateTaiLieuBangChungMulti.request('', { taiLieuBangChungs: UpdateTLList });
    }
    if (AddNewDDCList.length) {
      Reception.actions.postDoanDiCungMulti.request('', { doanDiCungs: AddNewDDCList });
    }
    if (UpdateDDCList.length) {
      Reception.actions.updateDoanDiCungMulti.request('', { doanDiCungs: UpdateDDCList });
    }

    if (!AddNewDCDList.length && !UpdateDCDList.length) {
      if (this.state.donDangXuLy) {
        if (onlySave) {
          this.patchXuLyDon(donId, this.state.params);
        } else {
          this.postXuLyDon(donId, this.state.params);
        }
      } else {
        this.onClickClose();
        Toastr(msg.xuLyDon, 'success');
      }
    }
    this.createDSTepDinhKem(donId, this.state.thongTinDon.dsFileCoQuan, 'THONG_TIN_DON', 'CO_QUAN_DA_GIAI_QUYET');
  }

  createTaiLieuBangChung(item, donID, stcdId, buocGQ = 'TAI_LIEU_KEM_THEO') {
    let params = {
      don: {
        id: donID
      },
      buocGiaiQuyet: buocGQ
    }
    if (item.ten) {
      params.ten = item.ten;
    }
    if (item.tinhTrang) {
      params.tinhTrangTaiLieu = item.tinhTrang;
    }
    if (item.tenFile) {
      params.tenFile = item.tenFile;
    }
    if (item.duongDan) {
      params.duongDan = item.duongDan;
    }
    if (item.required) {
      params.required = true;
    }
    if (stcdId) {
      params.soTiepCongDan = {
        id: stcdId
      };
    }
    if (item.taiLieuBangChungId) {
      params.id = item.taiLieuBangChungId;
    }
    return params;
  }

  createDonCongDan(cdData, donID, plusData, loaiCD) {
    let param = {
      phanLoaiCongDan: loaiCD,
      don: {
        id: donID
      }
    };
    if (cdData) {
      param = Object.assign(param, cdData);
    }
    if (plusData) {
      param = Object.assign(param, plusData);
    }
    return param;
  }

  createItemDoanDiCung(data, donId) {
    let params = {
      hoVaTen: data.hoVaTen,
      don: {
        id: donId
      }
    }
    if (data.diaChi) {
      params.diaChi = data.diaChi;
    }
    if (data.soDienThoai) {
      params.soDienThoai = data.soDienThoai;
    }
    if (data.cmndHoChieu) {
      params.cmndHoChieu = data.cmndHoChieu;
    }
    if (data.doanDiCungId) {
      params.id = data.doanDiCungId;
    }
    return params;
  }

  createCongDan(data, type) {
    let params = {
      hoVaTen: data.hoVaTen
    }
    if (data.tinhThanhId) {
      params.tinhThanh = {
        id: data.tinhThanhId
      };
    }
    if (data.quanHuyenId) {
      params.quanHuyen = {
        id: data.quanHuyenId
      };
    }
    if (data.phuongXaId) {
      params.phuongXa = {
        id: data.phuongXaId
      };
    }
    if (data.toThon) {
      params.toThon = data.toThon;
    }
    if (data.diaChi) {
      params.diaChi = data.diaChi;
    }
    if (data.soDienThoai) {
      params.soDienThoai = data.soDienThoai;
    }
    if (data.soCMNDHoChieu) {
      params.soCMNDHoChieu = data.soCMNDHoChieu;
    }
    if (data.noiCap) {
      params.noiCapCMND = {
        id: data.noiCap.value
      };
    }
    if (data.ngaySinh && data.ngaySinh != null) {
      params.ngaySinh = moment(data.ngaySinh, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    if (data.ngayCap && data.ngaySinh != null) {
      params.ngayCap = moment(data.ngayCap, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    if (data.gioiTinh) {
      params.gioiTinh = data.gioiTinh == 'male' ? true : false;
    }
    if (data.quocTichId) {
      params.quocTich = {
        id: data.quocTichId
      };
    }
    if (data.danTocId) {
      params.danToc = {
        id: data.danTocId
      };
    }
    if (data.donCongDanId) {
      params.id = data.donCongDanId;
    }
    if (data.congDanId && type != 'NGUOI_DUOC_UY_QUYEN') {
      params.congDan = {
        id: data.congDanId
      };
    }
    return params;
  }

  runDeleteTask() {
    let ddnParams = [];
    this.state.taskDelete.map((item, i) => {
      if (item.type == 'CONG_DAN') {
        Reception.actions.deleteDonCongDan.request({
          id: item.id
        });
      } else if (item.type == 'DOAN_DI_CUNG') {
        ddnParams.push({
          id: item.id
        });
      }
    });
    this.state.thongTinDon.dsBangChungRemove.map((item) => {
      Reception.actions.deleteTaiLieuBangChung.request({
        id: item
      });
    });

    this.state.thongTinDon.dsFileCoQuanRemove.map((item) => {
      Reception.actions.deleteTaiLieuBangChung.request({
        id: item
      });
    });

    if (this.state.uyQuyen && this.state.uyQuyen.luatSu && this.state.uyQuyen.luatSu.dsGiayUyQuyenRemove) {
      this.state.uyQuyen.luatSu.dsGiayUyQuyenRemove.map((item) => {
        Reception.actions.deleteTaiLieuBangChung.request({
          id: item
        });
      });
    }

    if (ddnParams.length) {
      Reception.actions.deleteDoanDiCungMulti.request(null, {
        doanDiCungs: ddnParams
      });
    }
  }
  xuLyDon() {
    this.setState({isSave: false}, () => {
      if (this.validateSubmitForm()) {
        this.state.saveTmp = false;
        this.createDon(false);
      }
    });
  }
  createDon(onlySave) {
    this.setState({isSave: onlySave}, () => {
      this.setState({
        btnSaving: onlySave
      })
      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      let params = {
        coUyQuyen: this.state.flagUyQuyen,
        coThongTinCoQuanDaGiaiQuyet: this.state.thongTinDon.flagCQDaGiaiQuyet,
        noiDung: this.state.thongTinDon.noiDung,
        loaiVuViec: this.state.thongTinDon.loaiVuViecId,
        nguonTiepNhanDon: this.state.nguonDon || null,
        ngayTiepNhan: moment(this.state.ngayTiepNhan, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
        loaiNguoiDungDon: this.state.loaiNguoiDungDonId,
        thanhLapDon: true,
        canBoXuLy: { id: this.props.userInfo.id },
        soNguoi: this.props.nguoiDungDon.length
      };

      if (this.state.daLayThongTinDonId) {
        params.daLayThongTinDonId = this.state.daLayThongTinDonId;
      }

      if (this.state.nguonDon == 'KHAC') {
        params.nguonDonKhac = this.state.nguonDonKhac;
      }

      if (this.state.thongTinDon.loaiDoiTuongId) {
        params.loaiDoiTuong = this.state.thongTinDon.loaiDoiTuongId;
      }
      if (this.state.thongTinDon.loaiDonId) {
        params.loaiDon = this.state.thongTinDon.loaiDonId;
      }

      if (!this.state.saveTmp) {
        params.saveTmp = this.state.saveTmp;
      }
      if (this.state.thongTinDon.layVuViecCu) {
        params.layVuViecCu = this.state.thongTinDon.layVuViecCu;
      }

      if (this.state.loaiNguoiDungDonId == 'DOAN_DONG_NGUOI') {
        params.soNguoi = this.state.soNguoi;
      }
      if (this.state.thongTinDon.linhVucCap1Id) {
        params.linhVucDonThu = { id: this.state.thongTinDon.linhVucCap1Id };
      }
      if (this.state.thongTinDon.linhVucCap2Id) {
        params.linhVucDonThuChiTiet = { id: this.state.thongTinDon.linhVucCap2Id };
      }
      if (this.state.thongTinDon.linhVucChiTietKhac) {
        params.linhVucChiTietKhac = this.state.thongTinDon.linhVucChiTietKhac;
      }

      if (this.state.thongTinDon.flagCQDaGiaiQuyet) {
        if (this.state.thongTinDon.coQuanDaGiaiQuyetDonThu) {
          params.coQuanDaGiaiQuyetDonThu = this.state.thongTinDon.coQuanDaGiaiQuyetDonThu;
        }
        if (this.state.thongTinDon.soVanBan) {
          params.soVanBanDaGiaiQuyet = this.state.thongTinDon.soVanBan;
        }
        if (this.state.thongTinDon.ngayBanHanh) {
          params.ngayBanHanhVanBanDaGiaiQuyet = moment(this.state.thongTinDon.ngayBanHanh, 'DD/MM/YYYY').add(7, 'hours').toISOString();
        }
      }

      this.runDeleteTask();

      if (this.state.donId != 0) {
        params.tongSoLuotTCD = this.state.tongSoLuotTCD;
        Reception.actions.updateDon.request({ id: this.state.donId }, params).then(res => {

          if (res.data) {

            this.setState({
              donId: res.data.donId
            });

            this.phanLoaiDonCongDan(res.data.donId, onlySave);
          }

        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
          this.setState({
            loadingSave: false,
            loadingXLD: false
          });
        });
      } else {
        Reception.actions.postDon.request(null, params).then(res => {
          if (res.data) {
            this.state.donId = res.data.donId;
            this.state.code = res.data.maHoSo;
            this.state.maTraCuuDialog = true;
            this.setState({...this.state});

            this.phanLoaiDonCongDan(res.data.donId, onlySave);
          }
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
          this.setState({
            loadingSave: false,
            loadingXLD: false
          });
        });
      }
    });
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (validator.props.checkValidate) {
        //do nothing
      } else {
        if (pass) {
          pass = validator.validate();
        }
        else {
          validator.validate();
        }
        if (!validator.validate() && get(validator, 'props.checkValid')) {
          pass = true;
        }
      }
    });
    return pass;
  }

  /* XULYDON */
  onClickClose() {
    browserHistory.push('/xu-ly-don');
  }

  handleDataForm(state) {

    let noticeMsg = state.notice;
    delete state.messege;
    this.state.params = state;
    this.state.noticeMsg = noticeMsg;
    this.state.hasChange = true;
    this.setState({...this.state});
  }

  handleInitDataForm(state) {
    this.setState({
      params: state
    });
  }

  getThongTinXuLy(donId) {

    LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(res => {

      if (res.data) {
        let info = res.data;

        this.props.dispatch({
          type: 'THONG_TIN_XU_LY_GIAI_QUYET',
          data: info.thongTinXuLyInfo
        });

        this.setState({
          alias: info.nextFormInfo.alias,
          thongTinXuLy: info.thongTinXuLyInfo
        });


      }
    }).catch(error => {
      if (error.response) {
      }
    })
  }

  getCurrentForm(donId) {
    LetterProcessingWorkFlow.actions.getCurrentForm.request({ donId: donId }).then(res => {
      if (res.data) {
        this.setState({
          processType: res.data.currentForm.processType,
          alias: res.data.currentForm.alias,
          listNextStates: res.data.listNextStates
        })
      }
    }).catch(error => {
      this.setState({
        donDangXuLy: false
      })
    })
  }

  postXuLyDon(donId, params) {
    this.setState({
      btnLoading: true
    });
    params.don = {
      id: donId
    }
    this.saveTepDinhKem(donId, () => {
      if (!this.state.params.donViNgoaiHeThongId && this.state.params.donViNgoaiHeThong) {
        Danhmuc.actions.postDonViNgoai.request(null, {ten: this.state.params.donViNgoaiHeThong.trim()}).then(res1 => {
          if (res1.data) {
            params.donViNgoaiHeThong = {id: res1.data.donViNgoaiHeThongId};
            LetterProcessingWorkFlow.actions.postXuLyDon.request(null, params).then(res => {
              if (!this.state.maTraCuuDialog) {
                this.onClickClose();
              }
              Toastr(this.state.noticeMsg, 'success');
            }).catch(error => {

              if (error.response) {
                Toastr(error.response.data.errors[0].detail, 'error');
              }
            });
          }
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
          }
        });
      } else {
        if (this.state.params.donViNgoaiHeThongId) {
          params.donViNgoaiHeThong = {id: this.state.params.donViNgoaiHeThongId};
        } else {
          params.donViNgoaiHeThong = null;
        }
        LetterProcessingWorkFlow.actions.postXuLyDon.request(null, params).then(res => {
          if (!this.state.maTraCuuDialog) {
            this.onClickClose();
          }
          Toastr(this.state.noticeMsg, 'success');
        }).catch(error => {

          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
        });
      }
    });
  }

  patchXuLyDon(donId, params) {
    params.don = {
      id: donId
    }
    this.saveTepDinhKem(donId, () => {
      if (!this.state.params.donViNgoaiHeThongId && this.state.params.donViNgoaiHeThong) {
        Danhmuc.actions.postDonViNgoai.request(null, {ten: this.state.params.donViNgoaiHeThong.trim()}).then(res1 => {
          if (res1.data) {
            params.donViNgoaiHeThong = {id: res1.data.donViNgoaiHeThongId};
            LetterProcessingWorkFlow.actions.patchXuLyDon.request({ id: donId }, params).then(res => {
              if (!this.state.maTraCuuDialog) {
                this.onClickClose();
              }
              Toastr(msg.xldLuu, 'success');
            }).catch(error => {
              if (error.response) {
                Toastr(error.response.data.errors[0].detail, 'error');
              }
            });
          }
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
          }
        });
      } else {
        if (this.state.params.donViNgoaiHeThongId) {
          params.donViNgoaiHeThong = {id: this.state.params.donViNgoaiHeThongId};
        } else {
          params.donViNgoaiHeThong = null;
        }
        LetterProcessingWorkFlow.actions.patchXuLyDon.request({ id: donId }, params).then(res => {
          if (!this.state.maTraCuuDialog) {
            this.onClickClose();
          }
          Toastr(msg.xldLuu, 'success');
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
        });
      }
    });
  }
  getMoreDonInfo(donData) {
    Reception.actions.getDonInfo.request({ id: donData.donId }).then(res => {
      if (res.data) {
        donData = {...donData, ...res.data};
      }
      this.setState({
        listTaiLieuVanThu : donData.listTaiLieuVanThu
      })

      let info = donData;
      info.listNguoiDungDon.map((item, i) => {
        this.props.dispatch({
          type: 'CHON_CONG_DAN',
          data: item,
          donCongDanId: item.donCongDanId,
          index: i
        })
      });

      if (info.coUyQuyen) {
        this.props.dispatch({
          type: 'CHON_CONG_DAN',
          data: info.nguoiDuocUyQuyen,
          donCongDanId: info.nguoiDuocUyQuyen.donCongDanId,
          index: -1
        });
      }

      let newState = { ...this.state };

      newState.donId = info.donId;

      newState.ngayTiepNhan = moment(info.ngayTiepNhan);
      newState.nguonDon = info.nguonTiepNhanDonInfo.giaTri;
      newState.nguonDonKhac = info.nguonTiepNhanDonInfo.giaTri == 'KHAC' ? info.nguonDonKhac : '';
      newState.loaiNguoiDungDonId = info.loaiNguoiDungDonInfo.giaTri;
      newState.daLayThongTinDonId = info.daLayThongTinDonId || '';

      this.setState({ ...newState });

      this.props.dispatch({
        type: 'INIT_EDIT_FORM',
        data: donData
      });
    });
  }

  getDonInfo(donId) {
    LetterProcessingWorkFlow.actions.getDonDetail.request({ id: donId }).then(res => {
      if (res.data) {
        this.getMoreDonInfo(res.data);
        this.setState({
          canBoDangXuLy: res.data.canBoDangXuLyInfo
        });
      }
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }

    })
  }

  // In phieu
  inPhieu(loaiPhieu) {
    this.setState({
      isSave: true,
      checkValidate: true
    }, ()=> {
      if ( this.validateSubmitForm() ) {
        this.setState({checkValidate: false});
          let URL = String(API_URL);
          let thamQuyenHanhChinhId = localStorage.getItem('thamQuyenHanhChinhId') || 0;
          let loaiDon = this.state.thongTinDon.loaiDonId == "DON_KHIEU_NAI" ?
            "khiếu nại" : this.state.thongTinDon.loaiDonId == "DON_TO_CAO" ?
            "tố cáo" : this.state.thongTinDon.loaiDonId == "DON_KIEN_NGHI_PHAN_ANH" ?
            "kiến nghị, phản ánh" : this.state.thongTinDon.loaiDonId == "DON_TRANH_CHAP_DAT" ?
            "tranh chấp đất" : "";
          let ngayTiepNhan = moment(new Date(this.state.ngayTiepNhan)).format('DD/MM/YYYY');
          let nguoiDungDon = this.props.nguoiDungDon[0];
          let noiCapCMND = nguoiDungDon.noiCapCMNDInfo ? nguoiDungDon.noiCapCMNDInfo : {ten: ''};
          if (nguoiDungDon.noiCap) {
            noiCapCMND = this.state.noiCapCMNDList.filter((item) => {
              return item.coQuanQuanLyId === nguoiDungDon.noiCap.value
            });
            if (noiCapCMND.length) {
              noiCapCMND = noiCapCMND[0];
            }
          }
          let cqTiepNhan = '';
          let donViTiepNhanDonId= '';
          if (loaiPhieu == 'CHUYEN_DON' && this.state.params.thamQuyenGiaiQuyet) {
            if (this.state.params.thamQuyenGiaiQuyet.id == thamQuyenHanhChinhId) {
              cqTiepNhan = this.state.params.coQuanTiepNhan.ten;
              donViTiepNhanDonId = this.state.params.coQuanTiepNhan.id;
            } else {
              cqTiepNhan = this.state.params.donViNgoaiHeThong;
            }
          }

          let ngayCap = moment(nguoiDungDon.ngayCap).format('DD/MM/YYYY') == 'Invalid date' ? (nguoiDungDon.ngayCap || '') : moment(nguoiDungDon.ngayCap).format('DD/MM/YYYY');
          let diaChiNguoiDungDon = '';
          let loaiDoiTuong = this.state.thongTinDon.loaiDoiTuongId == "CA_NHAN" ? "cá nhân" : this.state.thongTinDon.loaiDoiTuongId == "TO_CHUC" ? "tổ chức" : "";

          if (nguoiDungDon.diaChi)
            diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.diaChi + ', ';

          if (nguoiDungDon.toThon)
            diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.toThon + ', ';

          if (nguoiDungDon.phuongXaCongDan)
            diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.phuongXaCongDan.ten + ', ';

          if (nguoiDungDon.quanHuyenCongDan)
            diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.quanHuyenCongDan.ten + ', ';

          if (nguoiDungDon.tinhThanhCongDan)
            diaChiNguoiDungDon = diaChiNguoiDungDon + nguoiDungDon.tinhThanhCongDan.ten + ', ';

          diaChiNguoiDungDon = diaChiNguoiDungDon.slice(0, diaChiNguoiDungDon.length - 2);

          let noiDung = this.state.thongTinDon.noiDung;
          switch (loaiPhieu) {

            case "THU_LY":

              URL = URL + "/xuLyDons/inPhieuDeXuatThuLy?"
                + "loaiDon=" + loaiDon
                + "&ngayTiepNhan=" + ngayTiepNhan
                + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
                + "&diaChi=" + diaChiNguoiDungDon
                + "&donViXuLyId=" + this.props.userInfo.donViId
                + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu
                + "&ngayCap=" + ngayCap
                + "&noiCap=" + noiCapCMND.ten
                + "&noiDung=" + noiDung
                + "&coQuanTiepNhan=" + this.props.userInfo.tenCoQuanQuanLy;
              window.open(URL, "_self");
              return;

            case "DU_THAO_THONG_BAO_THU_LY":

              if (this.state.thongTinDon.loaiDonId == 'DON_KHIEU_NAI') {
                URL = URL + "/xuLyDons/inPhieuDuThaoThongBaoThuLyKhieuNai?"
                  + "ngayTiepNhan=" + ngayTiepNhan
                  + "&nguoiKhieuNai=" + nguoiDungDon.hoVaTen
                  + "&diaChiNguoiKhieuNai=" + diaChiNguoiDungDon
                  + "&SoCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu
                  + "&ngayCap=" + (nguoiDungDon.ngayCap ? moment(nguoiDungDon.ngayCap).format('DD/MM/YYYY') : '')
                  + "&noiCap=" + noiCapCMND.ten
                  + "&noiDungKhieuNai=" + noiDung
                  + "&donViXuLyId=" + this.props.userInfo.donViId
                  + "&coQuanTiepNhan=" + this.props.userInfo.tenCoQuanQuanLy;

              } else if (this.state.thongTinDon.loaiDonId == 'DON_TO_CAO') {

                URL = URL + "/xuLyDons/inPhieuDuThaoThongBaoThuLyGQTC?"
                  + "doiTuongGiaiQuyet=" + this.props.userInfo.tenCoQuanQuanLy
                  + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
                  + "&doiTuongBiToCao=" + loaiDoiTuong
                  + "&donId=" + this.state.donId
                  + "&donViXuLyId=" + this.props.userInfo.donViId
                  + "&noiDungToCao=" + noiDung;

              } else if (this.state.thongTinDon.loaiDonId == 'DON_KIEN_NGHI_PHAN_ANH') {

                URL = URL + "/xuLyDons/inPhieuDuThaoThongBaoThuLyKienNghi?"
                  + "loaiDon=" + loaiDon
                  + "&ngayTiepNhan=" + ngayTiepNhan
                  + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
                  + "&noiDung=" + noiDung
                  + "&donViXuLyId=" + this.props.userInfo.donViId
                  + "&diaChi=" + diaChiNguoiDungDon;
              }
              window.open(URL, "_self");
              return;

            case "CHUYEN_DON":
              if (cqTiepNhan) {
                if (this.state.thongTinDon.loaiDonId == 'DON_TO_CAO') {
                  URL = URL + "/xuLyDons/inPhieuChuyenDonToCao?"
                    + "&ngayTiepNhan=" + ngayTiepNhan
                    + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
                    + "&diaChiNguoiDungDon=" + diaChiNguoiDungDon
                    + "&noiDung=" + noiDung
                    + "&donViXuLyId=" + this.props.userInfo.donViId
                    + "&coQuanTiepNhan=" + cqTiepNhan
                    + "&donViTiepNhanDonId=" + donViTiepNhanDonId
                    + "&coQuanChuyenDon=" + this.props.userInfo.tenCoQuanQuanLy;
                } else if (this.state.thongTinDon.loaiDonId == 'DON_KIEN_NGHI_PHAN_ANH') {
                  URL = URL + "/xuLyDons/inPhieuChuyenDonKienNghiPhanAnh?"
                    + "ngayTiepNhan=" + ngayTiepNhan
                    + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
                    + "&diaChiNguoiDungDon=" + diaChiNguoiDungDon
                    + "&noiDung=" + noiDung
                    + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu
                    + "&ngayCap=" + ngayCap
                    + "&noiCap=" + noiCapCMND.ten
                    + "&donViXuLyId=" + this.props.userInfo.donViId
                    + "&coQuanTiepNhan=" + cqTiepNhan
                    + "&coQuanChuyenDon=" + this.props.userInfo.tenCoQuanQuanLy;
                }
                window.open(URL, "_self");
              } else {
                Toastr('Vui lòng chọn cơ quan tiếp nhận', 'warning');
              }
              return;

            case "KHONG_DU_DIEU_KIEN_THU_LY_KHIEU_NAI":
              let apiPrint = "/xuLyDons/inPhieuKhongDuDieuKienThuLyKhieuNai?";
              if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {
                apiPrint = "/xuLyDons/inPhieuKhongDuDieuKienThuLyToCao?";
              } else if (this.state.loaiDonGiaTri == 'DON_KIEN_NGHI_PHAN_ANH') {
                apiPrint = "/xuLyDons/inPhieuKhongDuDieuKienThuLyKienNghi?";
              }

              URL = URL + apiPrint
                + "&ngayTiepNhan=" + ngayTiepNhan
                + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
                + "&nguoiToCao=" + nguoiDungDon.hoVaTen
                + "&nguoiKienNghi=" + nguoiDungDon.hoVaTen
                + "&diaChiNguoiDungDon=" + diaChiNguoiDungDon
                + "&diaChiNguoiToCao=" + diaChiNguoiDungDon
                + "&diaChiNguoiKienNghi=" + diaChiNguoiDungDon
                + "&soCMNDHoChieu=" + nguoiDungDon.soCMNDHoChieu
                + "&ngayCap=" + ngayCap
                + "&noiCap=" + noiCapCMND.ten
                + "&noiDung=" + noiDung
                + "&donId=" + this.state.donId
                + "&donViXuLyId=" + this.props.userInfo.donViId
                + "&lyDo=" + this.state.params.yKienXuLy
                + "&lyDoDinhChi=" + this.state.params.yKienXuLy
                + "&coQuanTiepNhan=" + this.props.userInfo.tenCoQuanQuanLy;
              window.open(URL, "_self");
              return;

            case "HUONG_DAN":
              apiPrint = "/xuLyDons/inPhieuTraDonVaHuongDanKhieuNai?";
              if (this.state.loaiDonGiaTri == 'DON_TO_CAO') {
                apiPrint = "/xuLyDons/inPhieuHuongDanToCao?";
              }
              URL = URL + apiPrint
                + "&ngayTiepNhan=" + ngayTiepNhan
                + "&nguoiDungDon=" + nguoiDungDon.hoVaTen
                + "&soCMND=" + nguoiDungDon.soCMNDHoChieu
                + "&hoVaTen=" + nguoiDungDon.hoVaTen
                + "&diaChi=" + diaChiNguoiDungDon
                + "&ngayCap=" + ngayCap
                + "&noiCap=" + noiCapCMND.ten
                + "&noiDung=" + noiDung
                + "&donViXuLyId=" + this.props.userInfo.donViId
                + "&coQuanTiepNhan=" + this.props.userInfo.tenCoQuanQuanLy;
              window.open(URL, "_self");
              return;

            case "HUONG_DAN_DON_KIEN_NGHI_PHAN_ANH":
              apiPrint = "/xuLyDons/inPhieuHuongDanKienNghi?";
              URL = URL + apiPrint
                + "&ngayTiepNhan=" + ngayTiepNhan
                + "&hoVaTen=" + nguoiDungDon.hoVaTen
                + "&diaChi=" + diaChiNguoiDungDon
                + "&noiDung=" + noiDung
                + "&donViXuLyId=" + this.props.userInfo.donViId;
              window.open(URL, "_self");
              return;

            case "TRA_LAI_DON_KHONG_DUNG_THAM_QUYEN":

              URL = URL + "/xuLyDons/inPhieuTraDonChuyenKhongDungThamQuyen?"
                + "&coQuanNhanDon=" + this.props.userInfo.tenCoQuanQuanLy
                + "&coQuanChuyenDon=" + this.state.thongTinXuLyGiaiQuyet.coQuanChuyenDon.ten
                + "&hoTenNguoiCoDon=" + nguoiDungDon.hoVaTen
                + "&ngayTiepNhan=" + ngayTiepNhan
                + "&donViXuLyId=" + this.props.userInfo.donViId
                + "&noiDung=" + noiDung
                + "&diaChi=" + diaChiNguoiDungDon;
              window.open(URL, "_self");
              return;
          }
    }
    })
  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  hiddenLetterHistory(value) {
    this.setState({
      showHistory: value
    })
  }

  createDSTepDinhKem(donId, data, loaiQT, buocGQ) {
    let listAddNew = [];
    let listUpdate = [];

    data.map((item, i) => {
      if (item.ten) {
        let params = {
          don: { id: donId },
          loaiQuyTrinh: loaiQT,
          loaiTepDinhKem: 'QUYET_DINH'
        }
        if (item.ten) {
          params.ten = item.ten;
        }
        if (buocGQ) {
          params.buocGiaiQuyet = buocGQ;
        }
        if (item.tenFile) {
          params.tenFile = item.tenFile;
        }
        if (item.duongDan) {
          params.duongDan = item.duongDan;
        }
        if (item.required) {
          params.required = true;
        }
        if (item.typeRequired) {
          params.typeRequired = item.typeRequired;
        }
        if (item.soQuyetDinh) {
          params.soQuyetDinh = item.soQuyetDinh;
        }
        if (item.ngayQuyetDinh) {
          params.ngayQuyetDinh = moment(item.ngayQuyetDinh).toISOString();
        }
        if (item.taiLieuVanThuId) {
          params.id = item.taiLieuVanThuId;
          listUpdate.push(params);
        } else {
          listAddNew.push(params);
        }
      }
    });
    if (listAddNew.length) {
      Reception.actions.postTaiLieuVanThuMulti.request('', { taiLieuVanThus: listAddNew });
    }
    if (listUpdate.length) {
      Reception.actions.updateTaiLieuVanThuMulti.request('', { taiLieuVanThus: listUpdate });
    }

  }

  saveTepDinhKem(donId, callback) {

    this.state.dataFileDinhKem.map((item, i) => {
      if (item.taiLieuVanThuId) {
        this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
          don: {
            id: Number(donId)
          },
          id: item.taiLieuVanThuId,
          ten: item.ten,
          soQuyetDinh: item.soQuyetDinh,
          ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
          tenFile: item.tenFile,
          duongDan: item.duongDan,
          loaiTepDinhKem: item.loaiTepDinhKem,
          loaiQuyTrinh: item.loaiQuyTrinh,
          buocGiaiQuyet: null,
          required: item.required,
          typeRequired: item.typeRequired ? item.typeRequired : ''
        };
      } else {
        this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
          don: {
            id: Number(donId)
          },
          ten: item.ten,
          soQuyetDinh: item.soQuyetDinh,
          ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
          tenFile: item.tenFile,
          duongDan: item.duongDan,
          loaiTepDinhKem: this.state.loaiTepDinhKem,
          loaiQuyTrinh: this.state.loaiQuyTrinh,
          buocGiaiQuyet: null,
          required: item.required,
          typeRequired: item.typeRequired ? item.typeRequired : ''
        };
      }
    });

    if (this.state.dataTaiLieuVanThuDelete.length > 0) {
      this.state.dataTaiLieuVanThuDelete.map(item => {
        this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
          id: item
        };
      });
    }

    this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
      this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
        this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
          callback();
        });
      });
    });
  }

  onChangeTepDinhKem(tepDinhKem, deleteTepDinhKem, loaiQuyTrinh, loaiTepDinhKem) {
    this.setState({
      loaiQuyTrinh: loaiQuyTrinh,
      loaiTepDinhKem: loaiTepDinhKem,
      dataFileDinhKem: tepDinhKem,
      dataTaiLieuVanThuDelete: deleteTepDinhKem
    })
  }

  handleBack(allowBack) {
    if (allowBack) {
      browserHistory.goBack();
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({...this.state});
      } else {
        browserHistory.goBack();
      }
    }
  }

  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({...this.state});
  }
  closeMaTraCuuDialog() {
    this.setState({maTraCuuDialog: false});
    browserHistory.goBack();
  }

  render() {
    let valid = (current) => {
      return current.isBefore(moment());
    };

    return (
      <div>
        <MaTraCuuDialog open={this.state.maTraCuuDialog} code={this.state.code} onClose={this.closeMaTraCuuDialog.bind(this)} />
        <SearchFullNamePopup self={this.state} />
        <ListInfoDocumentDialog self={this.state} />
        <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
          title={msg.confirmBack} />

        <div id="page" className="add-reception panel-page">
          <div className="center">
            <div className="back-foward">
              <Link onClick={this.handleBack.bind(this, false)} title="">Về trang trước</Link>
            </div>
            <div className="heading">
              <h2 className="heading-title icon-add">
                {this.props.params.type == 'them-moi' ? 'THÊM MỚI ĐƠN/ VỤ VIỆC' : ''}
                {this.props.params.type == 'chinh-sua' ? 'CHỈNH SỬA ĐƠN/ VỤ VIỆC' : ''}
              </h2>
            </div>
            {this.state.dataLoading ? (
              <LoadingData />
            ) : (
                <div className="main_page">
                  <form className="form">
                    <div className="wrapper_box">
                      <div className="box-items">
                        <div className="box-forward ">
                          <div className="container-box">
                            <div className="group-box">
                              <div className="items-form">
                                <div className="row pl10 pr10 box-top">
                                  <div className="col-12">
                                    <DatePicker
                                      className="col-input mb0-18"
                                      label='Ngày tiếp nhận'
                                      name="ngayTiep"
                                      dateFormat="DD/MM/YYYY -"
                                      timeFormat="HH:mm"
                                      value={this.state.ngayTiepNhan}
                                      onChange={this.handleChangeDate.bind(this, 'ngayTiepNhan')}
                                      maxLength={18}
                                      isValidDate={valid} />
                                    <DropDownChonNguonDon
                                      selectedValue={this.state.nguonDon}
                                      bindValidator={this}
                                      require
                                      exceptNguonDon="GIAO_TTXM,GIAO_KTDX,TRUC_TIEP,CHUYEN_DON,GIAO_TDTH"
                                      onChange={this.onChange.bind(this, 'nguonDon')}
                                      className="col-input mb0-18"
                                    />
                                    {
                                      this.state.nguonDon == 'KHAC' &&
                                      <Input className="col-input mb0-18 mt21" name="nguonDonKhac" placeholder="Nhập nguồn đơn khác..." maxLength={255} value={this.state.nguonDonKhac} onChange={this.onChange.bind(this, 'nguonDonKhac')}/>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ThongTinNguoiDungDon
                        onChange={this.onChangeData.bind(this)}
                        onInit={this.onInitComponent.bind(this)}
                        bindValidator={this}
                        onSave={this.state.isSave}
                        onRemove={this.handleRemove.bind(this)} />
                      <ThongTinDon
                        checkValidate = {this.state.checkValidate}
                        onChange={this.onChangeData.bind(this)}
                        onInit={this.onInitComponent.bind(this)}
                        onSave={this.state.isSave}
                        bindValidator={this}
                        isTraCuu={true}
                        isDonCu={false}
                        xuLyDon={true} />
                      <ShowIf condition={this.state.showHistory && this.state.donId != 0}>
                        <LetterHistory pageType="THEM_MOI_VA_CHINH_SUA_DON" donId={this.state.donId} onChange={this.hiddenLetterHistory.bind(this)} />
                      </ShowIf>
                      {
                        this.props.params && this.props.params.type !== 'chinh-sua' &&
                          <FormXuLyHoacGiaiQuyet
                            checkValidate = {this.state.checkValidate}
                            thongTinDon={this.state.thongTinDon}
                            loaiDonKhongQuyTrinh={this.state.params}
                            loaiDonGiaTri={this.state.thongTinDon ? this.state.thongTinDon.loaiDonId : ''}
                            onChangeTepDinhKem={this.onChangeTepDinhKem.bind(this)}
                            thongTinXuLyGiaiQuyet={this.state.thongTinXuLy}
                            title={this.state.title}
                            alias={this.state.alias}
                            donId={this.state.donId}
                            listNextStates={this.state.listNextStates}
                            onChange={this.handleDataForm.bind(this)}
                            onInit = {this.handleInitDataForm.bind(this)}
                            validate={this.state.validate}
                            donDangXuLy={this.state.donDangXuLy}
                            processType={this.state.processType}
                            inPhieu={this.inPhieu.bind(this)}
                            trangThaiDonDonVi={{}}
                            bindValidator={this}
                            onSave={this.state.isSave}
                            action="them-moi"
                            listTaiLieuVanThu={this.state.listTaiLieuVanThu}
                            pageType="THEM_MOI_VA_CHINH_SUA_DON" />
                      }
                    </div>
                    <div className="mt30 mb30">
                      <ButtonGroup
                        canBoDangXuLy={this.state.canBoDangXuLy}
                        pageType="THEM_MOI_VA_CHINH_SUA_DON"
                        alias={this.state.alias}
                        donId={this.state.donId}
                        lanhDaoDuyet={this.state.lanhDaoDuyet}
                        params={this.state.params}
                        donDangXuLy={this.state.donDangXuLy}
                        processType={this.state.processType}
                        onClose={this.handleBack.bind(this, false)}
                        onSave={this.createDon.bind(this, true)}
                        onClickXuLyDon={this.xuLyDon.bind(this)}
                        btnLoading={this.state.btnLoading}
                        btnSaveLoading={this.state.btnSaveLoading}
                        onClickSaveFile={this.saveTepDinhKem.bind(this)}
                        validateSubmitForm={this.validateSubmitForm.bind(this)}
                        bindValidator={this}
                        trangThaiDonDonVi={{}}
                        btnSaving={this.state.btnSaving} />
                    </div>
                  </form>
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

AddHandleLetter.defaultProps = {
  validators: {},
  noiCapCMNDList: []
}

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    nguoiDungDon: state.formDataTiepCongDan.nguoiDungDon,
    nguoiUyQuyen: state.formDataTiepCongDan.nguoiUyQuyen,
    thongTinDon: state.formDataTiepCongDan.thongTinDonThu,
    noiCapCMNDList: state.duLieuHeThong.noiCapCMND,
    removeDonCongDanId: state.formDataTiepCongDan.removeDonCongDanId
  };
}

export default connect(bindStateToProps)(AddHandleLetter);



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/add-handle-letters/AddHandleLetter.jsx